export default [
    {
        "id": "register-with-address",
        "html": require('./register-with-address/html').default
    }
]